import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_URL from '../api/config';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import '../styles/style.css'; 
import { useQuery } from '@tanstack/react-query';
import { io } from 'socket.io-client';
import ReactModal from 'react-modal';
import ImageWithLoader2 from '../components/ImageWithLoader2';

import { useFamilyAdmin } from '../hooks/useFamilyAdmin';

const isLocalhost = window.location.hostname === 'localhost';
const SOCKET_URL = isLocalhost ? "http://localhost:8081" : "https://oret.africa";

const socket = io(SOCKET_URL, {
  path: "/tree/backend/socket.io",
  transports: ["polling", "websocket"],
  withCredentials: true,
  autoConnect: false
});

const Header= (props) => {

  const navigate = useNavigate();

  useFamilyAdmin();

  const location = useLocation();

    const [family_code, setFamilyCode] = useState(null);
    const [showFamilyModal, setShowFamilyModal] = useState(false);


	const handlesidebar=()=>{
		document.body.classList.toggle('mini-sidebar');
	}

	const onMenuClik = () => {
		props.onMenuClick()
	}

  

  // Load family_code from localStorage
    useEffect(() => {
      const family_code = localStorage.getItem('family_code');
      if (family_code) setFamilyCode(family_code);
    }, []);

//notifications
  const [notifications, setNotifications] = useState([]);
const [unreadCount, setUnreadCount] = useState(0);

useEffect(() => {
  if (!family_code) return;

  if (!socket.connected) {
    socket.connect();
  }

  socket.emit("check_pending_family_requests", { family_code });

  const interval = setInterval(() => {
    socket.emit("check_pending_family_requests", { family_code });
  }, 10000);

  socket.on("pending_request_status", (data) => {
    if (data.hasPending && data.count > 0) {
      const newNotif = {
        message:
          data.count === 1
            ? `There is ${data.count} pending family join request`
            : `There are ${data.count} pending family join requests`,
        timestamp: new Date().toLocaleTimeString(),
      };

      setNotifications((prev) => {
        const alreadyExists = prev.some((n) => n.message === newNotif.message);
        return alreadyExists ? prev : [newNotif, ...prev];
      });

      setUnreadCount((prev) => (prev === 0 ? 1 : prev));
    } else {
      setNotifications([]);
      setUnreadCount(0);
    }
  });

  return () => {
    socket.off("pending_request_status");
    clearInterval(interval);
  };
}, [family_code]);

///end notifications
	
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const toggleDropdown = (e) => {
		e.preventDefault();
		setDropdownOpen(!dropdownOpen);
	  };

    //start 

    // Fetch Family Name
 
     // Fetch Family Name
  const { data: familyNameData, isLoading, isError, refetch } = useQuery({
    queryKey: ['familyName'],
    queryFn: () =>
      axios.get(`${API_URL}/family-name-api`, { withCredentials: true })
        .then(res => res.data.family_name?.substring(0, 16) || ""),
    staleTime: 0,
    cacheTime: Infinity,
  });


  // Show modal if no family name, but NOT on family-info-update page
  useEffect(() => {
    if (
      !isLoading &&
      !isError &&
      (!familyNameData || familyNameData.trim() === "") &&
      location.pathname !== "/family-info-update" &&
      location.pathname !== "/family-info-update-clan" && 
      location.pathname !== "/family-info-update-clan-add" && location.pathname !== "/family-info-update-totem-add"
    ) {
      setShowFamilyModal(true);
    }
  }, [isLoading, isError, familyNameData, location.pathname]); // add location.pathname

    
       // Fetch User Details
  const { data: user, isLoadingP, isErrorP } = useQuery({
    queryKey: ['userDetails'],
    queryFn: () =>
      axios.get(`${API_URL}/user-details-api`, { withCredentials: true })
        .then(res => res.data),
    staleTime: 0,
    cacheTime: Infinity,
  });


  //fetch popup if invited is 1

  const [showInvitationModal, setShowInvitationModal] = useState(false);

  const {
    data: invitationData,
    isLoading: isLoadingInvitation,
    isError: isErrorInvitation
  } = useQuery({
    queryKey: ['checkInvitation'],
    queryFn: async () => {
      const res = await axios.get(
        `${API_URL}/check-user-invitation-api`,
        { withCredentials: true }
      );
  
      return res.data; // IMPORTANT
    },
    staleTime: 0,
    cacheTime: Infinity,
  });

  // Show modal if invited is 1, but NOT on these pages  
  useEffect(() => {
    if (
      !isLoadingInvitation &&
      !isErrorInvitation &&
      invitationData?.invited === 1 && // SHOW only if invited === 1
      location.pathname !== "/verify-invitation-info-update" &&
      location.pathname !== "/verify-invitation-info-confirm" &&
      location.pathname !== "/verify-invitation-reject" 
    ) {
      setShowInvitationModal(true);
    } else {
      setShowInvitationModal(false);
    }
  
  }, [
    isLoadingInvitation,
    isErrorInvitation,
    invitationData,
    location.pathname
  ]);

      
      // Fetch Chat Members with Unread Count
  const { data: chatList = [] } = useQuery({
    queryKey: ['chat-members-list'],
    queryFn: () => axios.get(`${API_URL}/chat-members-list`).then(res => res.data),
    staleTime: 5000,
    refetchInterval: 5000, // Optional: for live update
  });

  const totalUnread = Array.isArray(chatList)
  ? chatList.reduce((acc, curr) => acc + (curr.unread_count || 0), 0)
  : 0;
  

    
  return (

     <>
          {/* Family Name Missing Modal */}
          <ReactModal
             isOpen={showFamilyModal}
             onRequestClose={() => setShowFamilyModal(false)}
             className="Modal family-update-modal"
             overlayClassName="Overlay Overlay--blur"
           >
             <div className="family-update-card">
               <div className="family-update-icon">
                 <i className="bi bi-info-circle"></i>
               </div>
               <h5 className="family-update-title">Update Family Info</h5>
               <p className="family-update-sub">
                 Your family info is not set. Please update it to continue.
               </p>
               <button
                 className="btn family-update-btn"
                 onClick={() => {
                   setShowFamilyModal(false);
                   navigate('/family-info-update');
                 }}
               >
                 Update Now
               </button>
             </div>
           </ReactModal>


           <ReactModal
             isOpen={showInvitationModal}

             ariaHideApp={false}
  shouldCloseOnOverlayClick={false}
  shouldCloseOnEsc={false}
  onRequestClose={() => {}}

             
             className="Modal family-update-modal"
             overlayClassName="Overlay Overlay--blur"
           >
             <div className="family-update-card">
               <div className="family-update-icon">
                 <i className="bi bi-info-circle"></i>
               </div>
               <h5 className="family-update-title">Confirm your invitation info</h5>
               <p className="family-update-sub">
                 Your details info is not set. Please update it to continue.
               </p>
               <button
                 className="btn family-update-btn"
                 onClick={() => {
                  setShowInvitationModal(false);
                   navigate('/verify-invitation-info-update');
                 }}
               >
                 Update Now
               </button>
             </div>
           </ReactModal>
    

    
    
    <div class="header header-one" style={{backgroundColor: '#184A2C'}}>
    
    <div class="header-left header-left-one">
       
    {/*<Link to="/home" className="logo" style={{marginLeft: '-35%', color: '#ffff'}}>
			<img src="img/logo_1.png" alt="Logo" />
		</Link>*/}
        <a href="#" class="logo logo-small float-startx py-2 py-md-0 ms-4">

				
                    <span class=" d-flexx d-md-none align-items-centerx"> 
					
                            <p class="mt-3 h5 fw-bold d-none"></p>
                           
				</span>
            <span class="d-flex d-md-none align-items-center">
					
                           
                            {isLoading ? (
            <p class="h6 ms-2 text-white">Loading...</p>
            ) : isError ? (
            <p class="h6 ms-2 text-white">Family name here</p>
            ) : (
            <p class="h6 ms-2 text-white">{familyNameData || "No family name"}</p>
            )}

                  
                            
				</span>
        </a>
    </div>

    
    {/*<a href="#" id="toggle_btn" onClick={handlesidebar}> 
    <img src="img/logo_3.png" alt="Logo" style={{height: '40px'}} />
	  </a>*/}

      
    
    <a className="mobile_btn" id="mobile_btn"  href="#"  onClick={() => onMenuClik()}>
		
    <img src="img/logo_3.png" alt="Logo" style={{height: '30px'}} />
	</a>

  <div class="top-nav-header-name d-none d-md-block">
        
                
        {isLoading ? (
    <p class="mt-3 h3 fw-bold">Loading...</p>
    ) : isError ? (
    <p class="mt-3 h3 fw-bold">Family name here</p>
    ) : (
    <p class="mt-3 h3 fw-bold">{familyNameData || "No family name"}</p>
    )}

        
        
</div>
   

    
    <ul class="nav nav-tabs user-menu">
        
        <li class="nav-item dropdown">
            <a href="#" class="dropdown-toggle nav-link" data-bs-toggle="dropdown">
                <i className="fas fa-bell" style={{fontSize: '18px'}}></i>
                {unreadCount > 0 && (
                  <span className="badge rounded-pill bg-danger">{unreadCount}</span>
                )}
            </a>
            <div class="dropdown-menu notifications">
                <div class="topnav-dropdown-header">
                    <span class="notification-title">Notifications</span>


                </div>
                <div class="noti-content">
                <ul className="notification-list">
                      {notifications.length === 0 ? (
                        <li className="notification-message">No notifications yet</li>
                      ) : (
                        notifications.map((notif, index) => (
                          <li key={index} className="notification-message">
                            <div className="media d-flex align-items-start">
                              
                              <div className="media-body flex-grow-1 ms-2">
                                <p className="noti-details">{notif.message}</p>
                                <p className="noti-time"><span className="notification-time">{notif.timestamp}</span></p>
                              </div>
                            </div>
                          </li>
                        ))
                      )}
                    </ul>
                </div>

            </div>
        </li>

        
        <li class="nav-item dropdown">
            <a href="#" class="dropdown-toggle nav-link" data-bs-toggle="dropdown">
                <i className="fas fa-comment" style={{fontSize: '18px'}}></i>
                <span id="number_of_messagesXX"></span>
            </a>
            <div class="dropdown-menu notifications">
                <div class="topnav-dropdown-header">
                    <span class="notification-title">Messages</span>
                    
                </div>
                <div class="noti-content" >
                    <ul class="notification-list" id="messages_listXX">

                    </ul>
                </div>

            </div>
        </li>

 
               
               

    </ul>
    
</div>
</>
			
  );
}

export default Header;
